import React, { Component } from 'react'
import CollapseIconButton from 'components/fulcrum/collapse/CollapseIconButton'
import ModifyIconButton from './ModifyIconButton'
import InfoDialogButton from './InfoDialogButton'
import CancelEditButton from './CancelEditButton'
import { Flex } from 'reflexbox'
import { connect } from 'react-redux'
import Dialog from 'react-toolbox/lib/dialog'
import showOnAnyRoles from 'containers/Role/Show/AnyGlobalRoles'
import { PROJECT_ROLES, GLOBAL_ROLES, PRODUCT_ROLES } from 'containers/Role/constants'
import { mapProps, compose } from 'recompose'
import T from 'i18n-react'
import { projectWorkflowStateToChangeToSelector } from './selectors'
import { hideOnReadOnly } from 'helpers/projectUtil'
import { DIALOG_INACTIVE, DIALOG_DELETED, DIALOG_CANCELLED } from './constants'
const showToTeamOrClient = compose(
  mapProps((props) => ({
    ...props,
    roles: [
      ...Object.values(PROJECT_ROLES),
      ...Object.values(PRODUCT_ROLES),
      GLOBAL_ROLES.CLIENT_ACCESS,
      GLOBAL_ROLES.ADMIN_ACCESS
    ]
  })),
  showOnAnyRoles
)

const EditButton = compose(showToTeamOrClient, hideOnReadOnly)(ModifyIconButton)

const mapStateToProps = state => {
  return {
    stateToChangeTo: projectWorkflowStateToChangeToSelector(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

class Actions extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dialogState: DIALOG_INACTIVE
    }
  }

  getStateChangeDialogActions(){
    const { dialogState } = this.state
    const label_obj = {
      [DIALOG_INACTIVE]: '',
      [DIALOG_CANCELLED]: 'Cancel Project',
      [DIALOG_DELETED]: 'Delete Project'
    }
    return  [
      { label: "Back", onClick: () => this.dismissStateChangeDialog() },
      { label: label_obj[dialogState], onClick: () => {
        this.props.onSave()
        this.props.toggleEdit()
        this.dismissStateChangeDialog()
      }}
    ]
  }

  dismissStateChangeDialog() {
    this.setState({dialogState: DIALOG_INACTIVE})
  }
  onSave() {
    const { stateToChangeTo } = this.props
    if([DIALOG_CANCELLED, DIALOG_DELETED].includes(stateToChangeTo)){
      this.setState({dialogState: stateToChangeTo})
    } else {
      this.props.onSave()
      this.props.toggleEdit()
    }
  }

  render() {
    const {
      id, 
      edit, 
      toggleEdit, 
      disabled, 
      toggleCollapse, 
      collapse, 
      toggleDialogActive
    } = this.props

    const { dialogState } = this.state
    return (
      <Flex justify='flex-end'>
        {!edit &&
          <InfoDialogButton
            onClick={toggleDialogActive}
          />
        }
        {edit &&
          <CancelEditButton
            onClick={toggleEdit}
          />
        }
        <EditButton
          toggleEdit={() => {
            toggleEdit()
          }}
          edit={edit}
          onSave={() => this.onSave()}
          id={id}
          disabled={disabled}
        />
        <CollapseIconButton
          toggleCollapse={toggleCollapse}
          collapse={collapse}
        />
        <Dialog
          actions={this.getStateChangeDialogActions()}
          active={dialogState != DIALOG_INACTIVE}
          onEscKeyDown={() => this.dismissStateChangeDialog()}
          onOverlayClick={() => this.dismissStateChangeDialog()}
          title={T.translate(`project.lifecycle.stateChangeDialog.${dialogState}.title`)}
        >
          <p>{T.translate(`project.lifecycle.stateChangeDialog.${dialogState}.body`)}</p>
        </Dialog>
      </Flex>
    )
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Actions)